import type { ChatConfig, ChatMessage } from "../../types/chat.types";
import ChatHeader from "../ChatHeader/ChatHeader";
import MessageList from "../MessageList/MessageList";
import ChatFooter from "../ChatFooter/ChatFooter";
import QuickReplyButtons from "../QuickReplyButtons/QuickReplyButtons";
import styles from "./ChatWindow.module.css";

interface ChatWindowProps {
  config: ChatConfig;
  messages: ChatMessage[];
  onMinimize: () => void;
  onClose: () => void;
  onSendMessage: (sender: string, content: string) => void;
  isTyping: boolean;
  quickReplies?: { title: string }[];
  onSelectQuickReply?: (text: string) => void;
}

const ChatWindow = ({
  config,
  messages,
  onMinimize,
  onClose,
  onSendMessage,
  isTyping,
  quickReplies,
  onSelectQuickReply,
}: ChatWindowProps) => {
  return (
    <div 
      className={styles.chatWindow}
      role="dialog"
      aria-label="Chatt-dialog"
      aria-modal="true"
    >
       <ChatHeader
        botName={config.botDisplayName}
        botAvatarURL={config.botAvatarImageURL}
        onMinimize={onMinimize}
        onClose={onClose}
        visibleBotAvatar={config.visibleBotAvatar}
        minimizeButtonImage={config.minimizeChatImageURL}
        closeButtonImage={config.closeChatImageURL}
      />
      <MessageList
        messages={messages}
        showTypingDots={isTyping}
        introMessageText={config.introMessageText}
        greetingMessages={config.greeting.messages}
        onSelectQuickReply={(value) => {
          onSendMessage("Du", value);
        }}
      />
      {quickReplies && (
        <QuickReplyButtons
          options={quickReplies}
          onSelect={(text) => {
            onSendMessage("Du", text);
            onSelectQuickReply?.(text);
          }}
        />
      )}
      <ChatFooter
        onSend={(msg) => onSendMessage("Du", msg)}
        sendButtonImageUrl={config.sendMessageImageURL}
      />
    </div>
  );
};

export default ChatWindow;
